export const $address = Symbol('address');
export const $token = Symbol('token');
export const $tokens = Symbol('tokens');
export const DARK_MODE_CONDITION = '@media (prefers-color-scheme: dark)';
